import React, { useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import {
  Box,
  Button, Flex,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
  useDisclosure
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../constants/analyticsIds';
import { BusinessTypesDisplayNames } from '../../constants/businessTypes';
import { inAppText } from '../../constants/inAppText';
import colors from '../../styles/theme/foundation/colors';
import { getPrimaryButtonStyles } from '../../styles/theme/util/dropdownStylesUtil';
import {
  activeStyle,
  hoverStyle
} from '../../styles/theme/util/popoverMenuButtonStyles';
import InputLabel from '../form/InputLabel';

import Content from './Content';

function BusinessTypesDropdown({ defaultValue, onChange = () => {} }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentValue, setValue] = useState();

  const onSelect = value => {
    setValue(value);
    onChange(value);
    onClose();
  };

  const buttonText = BusinessTypesDisplayNames[currentValue]
      || BusinessTypesDisplayNames[defaultValue]
      || defaultValue
      || 'None Selected';

  return (
    <Box mb="26px" w="100%" dusk="businessTypes">
      <InputLabel labelName="Business Type" toolTip={inAppText.tooltips.insureds.newInsured.businessType} />
      <Popover
        closeOnBlur
        isOpen={isOpen}
        returnFocusOnClose={false}
        onClose={onClose}
        onOpen={onOpen}
      >
        <PopoverTrigger>
          <Button
            _active={activeStyle}
            _hover={hoverStyle}
            data-analytics-id={analyticsIds.insuredsListPage.createInsuredForm.businessTypeDropdown}
            style={getPrimaryButtonStyles(currentValue, isOpen)}
            variant="unstyled"
            width="100%"
          >
            <Flex
              alignItems="center"
              justify="space-between"
              overflow="hidden"
              pointerEvents="none"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              width="100%"
            >
              <Text
                color={buttonText === 'None Selected' ? colors.greyScale['500'] : colors.greyScale['900']}
                width="90%"
              >
                {buttonText}
              </Text>
              <Icon as={BsChevronDown} color={isOpen ? 'inherit' : colors.greyScale['500']} />
            </Flex>
          </Button>
        </PopoverTrigger>
        <PopoverContent maxH={300} overflowY="auto" width="400px">
          <Content defaultValue={defaultValue} onChange={onSelect} />
        </PopoverContent>
      </Popover>
    </Box>

  );
}

BusinessTypesDropdown.propTypes = {
  onChange: PropTypes.func,
  defaultValue: PropTypes.string
};

export default BusinessTypesDropdown;
